import { render } from "./layout-hovered.vue?vue&type=template&id=37d7650c"
import script from "./layout-hovered.vue?vue&type=script&lang=js"
export * from "./layout-hovered.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__